import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import DragDropList from 'Components/DragDropList';
import { Alert } from '@mui/material';

import {
    Grid,
    Collapse,
    Card,
    CardContent,
    CardHeader,
    Chip
} from '@mui/material';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import { Input } from 'Components';
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import DeleteIcon from "@mui/icons-material/Delete";
import ControlCameraIcon from '@mui/icons-material/ControlCamera';

const QuestionCreateEdit = (props) => {
    const { messages } = useIntl();
    const { data, callback, array_move, changeDragDisabled, DeleteQuestion } = props;
    const [expand, setExpand] = useState(false);
    const [answer, setAnswer] = useState(data?.answers);
    const [name, setName] = useState(data.name);
    const [answerText, setAnswerText] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        if (!data?.id)
            setExpand(true)
    }, []);

    useEffect(() => {
        callback({
            ...data,
            answers: answer,
            name: name
        })
    }, [answer, name]);


    return (
        <Card className="cardFormEdit">
            <CardHeader
                avatar={
                    <Avatar className="avatarIconForm" aria-label="recipe">
                        {data.priority}
                    </Avatar>
                }
                action={
                    <>
                        <IconButton aria-label="settings" onClick={() => setExpand(!expand)} size="large">
                            {
                                expand &&
                                <KeyboardArrowUpIcon fontSize="small" />
                            }

                            {
                                !expand &&
                                <KeyboardArrowDownIcon fontSize="small" />
                            }

                        </IconButton>

                        <IconButton
                            aria-label="settings"
                            onMouseEnter={() => {
                                changeDragDisabled(true)
                            }}
                            size="large">
                            <ControlCameraIcon fontSize="small" />
                        </IconButton>
                        <IconButton aria-label="delete" onClick={() => DeleteQuestion(data)} size="large">
                            <DeleteIcon fontSize="small" />
                        </IconButton>
                    </>
                }
                title={name}
            />
            <Collapse in={expand} timeout="auto" unmountOnExit>
                <CardContent onMouseOver={() => {
                    changeDragDisabled(false)
                }}>

                    {
                        error &&
                        <Alert severity="error" onClose={() => setError('')}>{error}</Alert>
                    }
                    <Grid
                        container
                        justifyContent={'center'}
                        direction={'column'}
                    >

                        <Grid item xs={12} >
                            <Input
                                id="name"
                                type="text"
                                label={messages['fsm_settings_form_title']}
                                placeholder={messages['fsm_settings_form_title']}
                                value={name}
                                onChange={(value) => setName(value)}
                                required
                                requiredMessage={messages['required_field']}
                                maxLength={30}
                            />
                        </Grid>
                        <Grid item xs={12} className="formAnswers">
                            <Input
                                id="answer"
                                type="inline"
                                label={messages['fsm_settings_form_answer']}
                                placeholder={messages['fsm_settings_form_answer']}
                                value={answerText}
                                disabledEditMode={true}
                                onChange={(value) => {
                                    let validationAnswer = answer?.filter(a => a.name == value);
                                    if (value && validationAnswer?.length===0){
                                        setAnswer([{
                                            keys: answer.length,
                                            name: value
                                        }, ...answer]);
                                    }else{
                                        setError(messages['fsm_settings_form_error_answer_duplicate']);
                                    }
    
                                }}
                                onFocus
                                requiredMessage={messages['required_field']}
                                maxLength={40}
                            />

                        </Grid>
                        <Grid item xs={12} className="formAnswers">

                            <DragDropList
                                items={answer}
                                keyName="keys"
                                itemRenderer={(items) => {
                                    return (
                                        <div style={{ marginTop: 12 }}>
                                            <Chip label={items.name} variant="outlined"
                                                onDelete={() => {
                                                    const key = items.keys;
                                                    const newAnswers = answer?.filter(a => a.keys !== key);
                                                    const resultArray = newAnswers.map((q, cont) => {
                                                        return {
                                                            ...q,
                                                            keys: cont,
                                                        };
                                                    });
                                                    setAnswer(resultArray)
                                                }}
                                            />
                                        </ div>
                                    )
                                }}
                                onDragEnd={(r) => {
                                    const newAnswer = array_move([...answer], r.source.index, r.destination.index);
                                    setAnswer(newAnswer)
                                }}
                            />

                        </Grid>

                    </Grid>
                </CardContent>
            </Collapse>
        </Card>
    );
}

export default QuestionCreateEdit;